export function RecurrenceInfoSection() {
  return (
    <div className="max-w-2xl p-6 border rounded-xl bg-white shadow">
      <h3 className="font-bold text-2xl mb-6 border-b border-ananas">
        Comment fonctionne la génération des horaires ?
      </h3>

      <p className="text-gray-700 leading-relaxed">
        Le calendrier affiche toujours{" "}
        <strong>la semaine actuelle au complet</strong>, même si nous sommes
        déjà au milieu de celle-ci.
      </p>

      <p className="text-gray-700 leading-relaxed mt-3">
        Ensuite, les semaines de récurrence que vous choisissez commencent{" "}
        <strong>à partir du prochain dimanche</strong>.
      </p>

      <div className="mt-4 p-3 bg-ananas/20 border-l-4 border-ananas ">
        <p className="text-sm text-gray-800">
          <strong>Exemple :</strong>
          <br />
          Si nous sommes <strong>mercredi le 10</strong> et que vous
          sélectionnez <strong>4 semaines</strong> :
        </p>

        <ul className="text-sm text-gray-700 mt-2 list-disc ml-6">
          <li>La semaine courante (dimanche → samedi) sera affichée.</li>
          <li>
            Les <strong>4 semaines suivantes</strong> seront générées à partir
            du <strong>dimanche qui s’en vient</strong>.
          </li>
        </ul>

        <p className="text-sm text-gray-700 mt-2">
          Donc vous verrez :
          <br />• la semaine actuelle,
          <br />• + 4 semaines complètes de disponibilités.
        </p>
      </div>

      <p className="text-gray-600 text-sm mt-3">
        Ce fonctionnement garantit que vos clients voient un calendrier propre,
        aligné par semaines, sans dates manquantes.
      </p>
    </div>
  );
}
